// src/utils/apiClient.js
// ═══════════════════════════════════════════════════════════════════
//  NearMe Central API Client
//  Sirf yahan key change karo — poori website update
//  fetch() aur axios dono ke liye kaam karta hai
//  Ola Maps / geoplugin / local URLs → key nahi lagegi
// ═══════════════════════════════════════════════════════════════════

import axios from "axios";

const NEARME_API_KEY = "NearMeInd-API-2025-SecureKey-Production-ready-for-nearme-app-website-only";

const NEARME_HOSTS = [
  "nearmeind.com",
  "nearmeindwebapi.nearmeind.com",
  "nearmeindapi.nearmeind.com",
];

function isNearMeUrl(url) {
  try {
    const host = new URL(url).hostname.toLowerCase();
    return NEARME_HOSTS.some((h) => host === h || host.endsWith(`.${h}`));
  } catch {
    // Relative URL — nearme ki hi hogi
    return true;
  }
}

function nearMeHeaders(extra = {}) {
  return {
    Accept: "application/json",
    "X-API-Key": NEARME_API_KEY,
    ...extra,
  };
}

// apiFetch — fetch() ki jagah
export async function apiFetch(url, options = {}) {
  if (isNearMeUrl(url)) {
    options.headers = nearMeHeaders(options.headers || {});
  }
  return fetch(url, options);
}

// apiAxios — axios ki jagah
export const apiAxios = axios.create();

apiAxios.interceptors.request.use((config) => {
  const fullUrl = config.baseURL
    ? config.baseURL + (config.url || "")
    : config.url || "";
  if (isNearMeUrl(fullUrl)) {
    config.headers["X-API-Key"] = NEARME_API_KEY;
    config.headers["Accept"] = config.headers["Accept"] || "application/json";
  }
  return config;
});
